import './bootstrap'
import 'flyonui/dist/dropdown.mjs'
import 'flyonui/dist/accordion.mjs'
import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'
import './site'

window.Alpine = Alpine

    ; (async () => {
        if (document.querySelector('[x-masonry]')) {
            const { default: masonry } = await import('alpinejs-masonry')
            Alpine.plugin(masonry)
        }

        Alpine.plugin(mask)

        Alpine.start()
    })()
